import { TextInput } from "@datagame/ui";
import { DemographicResponse } from "../types";
import { GameVisuals } from "../../../../gql/graphql";
import styles from "../../QuizGame.module.scss";

interface DemographicNumberInputProps {
  value: number | undefined;
  gameVisuals: GameVisuals;
  onChange: (response: Partial<DemographicResponse>) => void;
  placeholder?: string;
  min?: number;
  max?: number;
  autoFocus?: boolean;
}

export const DemographicNumberInput = ({
  value,
  gameVisuals,
  onChange,
  placeholder = "Enter your age",
  min = 0,
  max = 120,
}: DemographicNumberInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const numericValue = inputValue ? parseInt(inputValue) : undefined;

    // Validate range
    if (numericValue === undefined || (numericValue >= min && numericValue <= max)) {
      onChange({ numberValue: numericValue });
    }
  };

  return (
    <TextInput
      type="number"
      value={value?.toString() || ""}
      onChange={handleChange}
      customColor={gameVisuals.themeColor}
      placeholder={placeholder}
      min={min}
      max={max}
      className={styles.demographicNumberInput}
      size="large"
    />
  );
};
